module.exports = __webpack_public_path__ + "static/media/stanford_logo.5636f2b1.png";